import { render, staticRenderFns } from "./MultiSelectObject.vue?vue&type=template&id=48154742&scoped=true&"
import script from "./MultiSelectObject.vue?vue&type=script&lang=js&"
export * from "./MultiSelectObject.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectObject.vue?vue&type=style&index=0&id=48154742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48154742",
  null
  
)

export default component.exports